<div class="container-fluid plan-distribution-container" *ngIf="planDetails">
  <div class="row breadcrumb-row">
    <div class="col">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a routerLink="/plans">
            {{"plan.page.title" | translate}}
          </a>
          <esp-icon class="breadcrumb-separator" name="chevron-right"></esp-icon>
          <a [routerLink]="['..']">
            {{planName}}
          </a>
        </li>
      </ol>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col page-header plan-detail">
      <wfm-page-title title="{{'plan.dist.page.title'|translate}}"></wfm-page-title>
    </div>
    <div class="col text-right header-actions">
      <button id="cancel" class="btn btn-secondary btn-lg no-right-margin" [ngClass]="{'disabled': _isEditing}" [disabled]="_isEditing" [routerLink]="['..']" title='{{"plan.dist.return.plan" | translate}}'>{{"plan.dist.return.plan" | translate}}</button>
      <button id="apply" (click)="applyChanges()" [ngClass]="{'disabled': _isLoading || _isGridValid==false || _isPristine || _isEditing}" class="btn btn-primary btn-lg no-right-margin" [disabled]="_isLoading || _isGridValid==false || _isPristine || _isEditing" title='{{"plan.apply.btn" | translate}}'>{{"plan.apply.btn" | translate}}</button>
      <breeze-button class="d-none" buttonText="Close" id="btn-cancel-plan" [isPrimary]="true" btnSizeClass="btn-lg no-right-margin">
      </breeze-button>

    </div>
  </div>
  <div class="row toolbar-container text-left no-gutters">
    <div class="vertical-align-middle">
      <span class="toolbar-label" >{{"plan.dist.mu.dropdown.label" | translate}}</span>
      <wfm-select
                  class="muSelectorDropDown toolbar-select"
                  selectName="name"
                  selectId="id"
                  [items]="muList"
                  [disabled]="_isLoading || _isGridValid==false"
                  (wfmSelectEvent)="updateSelectedMU($event)"
                  [selectedItem]="selectedMU">
      </wfm-select>
      <div class="embedded-info borderless" *ngIf="isReadOnly">
        <esp-icon class="embedded-icon" name="info"></esp-icon>
        {{"plan.dist.read.only.message" | translate}}
      </div>
    </div>
    <div class="text-right">
      <breeze-button buttonText="{{'plan.dist.discard.btn'|translate}}"
                     id="discard-btn"
                     *ngIf="!isReadOnly"
                     [isSecondary]="true"
                     [isDisabled]="_isLoading || _isPristine || _isEditing"
                     (clicked)="showDiscardDlg()"></breeze-button>
    </div>
  </div>
  <div class="row slider" >
    <div class="col slide" style="">
      <div class="table-list editable-grid multi-cell-edit" [ngClass]="{'read-only':isReadOnly}">
        <ag-grid-angular class="ag-theme-balham" style="width: 100%; height: 100%;"
                        [rowData]="rowData"
                        #grid
                        [rowClassRules]="rowClassRules"
                        [rowHeight]="36" [headerHeight]="40"
                        [columnDefs]="colDefs"
                        [rowData]="rowData"
                        [gridOptions]="gridOptions"
                        suppressNoRowsOverlay="true"
                        [suppressRowTransform]="true"
                        [cellSelection]="cellSelection"
                        [rowSelection]="rowSelection"
                        [stopEditingWhenCellsLoseFocus]="true"
                        [components]="frameworkComponents"
                        [loadingOverlayComponent]="'planLoadingOverlay'"
                        [context]="gridContext"
                        (gridReady)="onGridReady($event)"
                        [enableBrowserTooltips]="true"
                        [animateRows]="false"
                        (cellEditingStarted)="cellEditingStarted($event)"
                        (cellEditingStopped)="cellEditingStopped($event)"
                        (cellValueChanged)="cellValueChanged($event)">
        </ag-grid-angular>

      </div>
    </div>
  </div>
</div>
<wfm-task-progress [task]="task" *ngIf="task" [canCancel]="false">

</wfm-task-progress>
<wfm-plan-loading-overlay *ngIf="!planDetails"></wfm-plan-loading-overlay>
<p-toast position="bottom-right" [baseZIndex]="50">
</p-toast>
<div class="dialog-container"></div>

